module.exports = __webpack_public_path__ + "static/media/pricolIcon.0cf5e60b.svg";